import { useMutation, useQuery } from 'react-query'

import { Report17CreateFormTypes, } from "schemas/report-17-schemas";
import { postReport17Service } from "api/report-17";

export const useReport17Query = (payload: Report17CreateFormTypes) => {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useReport17Query', payload],
    queryFn: async () => {
      return await postReport17Service(payload);
    },
  })
  
  return query;
}


export const useReport17Mutation = () => {
  // const queryClient = useQueryClient();
  
  const mutationFn = async (payload: Report17CreateFormTypes) => {
    return await postReport17Service(payload);
  };

  const mutation = useMutation({
    mutationFn,
    // onError: (error: string) => {},
    // onSuccess: (data) => {},
  });

  return mutation;
};
